var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFbSmall = function SvgFbSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.186523,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 3.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1865 13.5609C23.1865 8.00304 18.7107 3.5 13.1865 3.5C7.66233 3.5 3.18652 8.00304 3.18652 13.5609C3.18652 18.5824 6.84338 22.7446 11.624 23.5V16.4692H9.0837V13.5609H11.624V11.3442C11.624 8.82292 13.116 7.43022 15.401 7.43022C16.4954 7.43022 17.6397 7.62657 17.6397 7.62657V10.1012H16.3785C15.1365 10.1012 14.749 10.8769 14.749 11.6724V13.5609H17.5224L17.0789 16.4692H14.749V23.5C19.5297 22.7446 23.1865 18.5824 23.1865 13.5609Z",
    fill: "#0A0A0A"
  })));
};
export default SvgFbSmall;